import React, { Component } from "react";
import EsriLoaderReact from "esri-loader-react";

import LeftBar from "./components/LeftBar";
import RightBar from "./components/RightBar";
import Modal from "./components/Modal";
import Constants from "./constants";
import { dataObject, contourTilesLayerTitle, earthquakeTileLayerTitle } from "./constants";
import "./App.css";
import loadingIcon from "./img/loading-icon.svg";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      testWebMap: null,
      yearLevel: 0,
      seaLevel: 0,
      stormLevel: 0,
      loader: false,
      contoursVisible: true,
      loadingIconFunction: null,
      displayModal:false,
      firstSession:true,
      acknowledge: false
    };
  }

  getAcknowledge = () => {
    return this.state.acknowledge;
  }

  setAcknowledge = (value) => {
    this.setState(
      {
        acknowledge: value
      }
    );
  }

  getDisplayModal = () => {
    return this.state.displayModal;
  }

  setDisplayModal = (value) => {
    this.setState(
      {
        displayModal: value
      }
    );
  }

  getFirstSession = () => {
    return this.state.firstSession;
  }

  setFirstSession = (value) => {
      this.setState({
        firstSession: value
      })
  }

  setContoursVisible = value => {
    this.setState(
      {
        contoursVisible: value
      },
      () => {
        this.setContourLayerVisibility(this.getContoursVisible());
      }
    );
  };

  getContoursVisible = () => {
    return this.state.contoursVisible;
  };

  setContourLayerVisibility = visibility => {
    const { testWebMap } = this.state;
    if (!testWebMap) return;
    const contoursLayer = testWebMap.layers.items.find(layer => {
      return layer.title === contourTilesLayerTitle;
    });

    contoursLayer.visible = visibility;
  };

  getYearLevel = () => {
    const { yearLevel } = this.state;
    return yearLevel;
  };

  getSeaLevel = () => {
    const { seaLevel } = this.state;
    return seaLevel;
  };

  getStormLevel = () => {
    const { stormLevel } = this.state;
    return stormLevel;
  };


  setYearLevel = level => {
    if(!this.getAcknowledge() && level !== 0) {
      this.setFirstSession(false);
      this.setDisplayModal(true);

    } else {
      this.setState(
        {
          yearLevel: level,
          seaLevel: 0,
          stormLevel: 0
        },
        () => {

          this.loadLayer();
        }
      );
    }

  };

  setSeaLevel = level => {
    this.setState(
      {
        seaLevel: level,
        stormLevel: 0
      },
      () => {
        this.loadLayer();
      }
    );
  };

  setStormLevel = level => {
    this.setState(
      {
        stormLevel: level
      },
      () => {
        this.loadLayer();
      }
    );
  };

  loadLayer = () => {
    const { testWebMap } = this.state;
    const earthquakeLayer =
    testWebMap.layers.items.find(layer => {
          return layer.title === earthquakeTileLayerTitle;
        });

    earthquakeLayer.sublayers.items.forEach((item, i) => {
      item.visible = false;
    });

    let layerToChange = 0;
      if(this.getYearLevel() !== 0) {
        layerToChange = (this.getSeaLevel() * 5) + this.getStormLevel() + 1;
      }
    earthquakeLayer.sublayers.items[layerToChange].visible = true;
  };

  onMapReady = async ({ loadedModules, containerNode }) => {
    const [
      WebMap,
      MapView,
      Search,
      TileLayer,
      Basemap,
      VectorTileLayer,
      FeatureLayer,
      Home,
      Extent,
      SpatialReference,
      Compass,
      watchUtils,
      MapImageLayer
    ] = loadedModules;

    const baseLayer = new TileLayer({
      url: Constants.baseMapUrl
    });

    const myBaseMap = new Basemap({
      baseLayers: [baseLayer]
    });

    //extent
    const newExtent = new Extent({
      xmax: 1886580.0000000037,
      xmin: 1872761.538900002,
      ymax: 5830237.462890627,
      ymin: 5816494.106,
      spatialReference: new SpatialReference({ wkid: 2193 })
    });

    const webMap = new WebMap({
      basemap: myBaseMap
    });

    const mapView = new MapView({
      container: containerNode,
      map: webMap,
      extent: newExtent,
      //zoom: 8,
      constraints: {
        minScale: 70000
      }
    });

    const propertyTilesLayer = new MapImageLayer({
      url: Constants.propertyTileLayer,
      title: "property"
    });

    const aerialLayer = new MapImageLayer({
      url: Constants.aerialLayer,
      title: "Aerial",
      sublayers: [
        {
          id: 0,
          visible: true,
          labelsVisible: true
        },
        { id: 1, visible: true, labelsVisible: true },
        { id: 2, visible: true, labelsVisible: true },
        { id: 3, visible: true, labelsVisible: true },
        { id: 4, visible: true, labelsVisible: true },
        { id: 5, visible: true, labelsVisible: true },
        { id: 6, visible: true, labelsVisible: true },
        { id: 7,  visible: true, labelsVisible: true },
        { id: 8,  visible: true, labelsVisible: true }
      ],
      visible: true
    });

    const contourTilesLayer = new MapImageLayer({
      url: Constants.contourTilesLayer,
      title: contourTilesLayerTitle
    });

    const earthquakeLayer = new MapImageLayer({
      url: Constants.earthquakeLayerUrl,
      title: earthquakeTileLayerTitle,
      sublayers: [
        {
          id: 0,
          visible: true,
          labelsVisible: false
        },
        { id: 1, visible: false, labelsVisible: false },
        { id: 2, visible: false, labelsVisible: false },
        { id: 3, visible: false, labelsVisible: false },
        { id: 4, visible: false, labelsVisible: false },
        { id: 5, visible: false, labelsVisible: false },
        { id: 6, visible: false, labelsVisible: false },
        { id: 7, visible: false, labelsVisible: false },
        { id: 8, visible: false, labelsVisible: false },
        { id: 9, visible: false, labelsVisible: false },
        { id: 10, visible: false, labelsVisible: false }
      ],
      opacity: 0.4
    });

    webMap.add(aerialLayer);
    webMap.add(earthquakeLayer);
    webMap.add(propertyTilesLayer, 0);
    webMap.add(contourTilesLayer);


    var symbol = {
      type: "simple-fill",
      style: "none",
      outline: {
        color: "#00ACD8",
        width: 2
      }
    };

    const compass = new Compass({
      view: mapView
    });

    const homeButton = new Home({
      view: mapView
    });


    const mapAnimation = scaleValue => {
      mapView.goTo(
        {
          scale: scaleValue
        },
        { duration: 1000 }
      );
    };

    const searchWidget = new Search({
      view: mapView,
      sources: [
        {
          layer: new FeatureLayer({
            url: Constants.propertySearchLayer,
            overwriteActions: true,
          }),
          searchFields: ["LOCATIONADDRESS"],
          displayField: "LOCATIONADDRESS",
          exactMatch: false,
          outFields: ["*"],
          name: "LOCATIONADDRESS",
          placeholder: "example: 100 Hull road",
          resultSymbol: {
            type: "simple-fill",
            style: "none",
            outline: {
              color: "#FFAA00",
              width: 2,
            },
          },
        },
      ],
      searchAllEnabled: false,
      includeDefaultSources: false,
      popupEnabled: false,
      goToOverride: (mapView, goToParams) => {
        goToParams.options.duration = 400
        return mapView.goTo(goToParams.target, goToParams.options)
      },
    });

    mapView.ui.add(
      searchWidget,
      {
        position: "top-right",
      }
    )

    searchWidget.on("select-result", () => {
      mapAnimation(400);
    });

    mapView.ui.move("zoom", "top-left");
    mapView.ui.add(homeButton, { position: "top-left" });
    mapView.ui.add(compass, { position: "top-left" });

  

    const loadingIconFunction = async () => {
      await watchUtils.whenTrueOnce(mapView, "updating", () => {
        this.setState({ loader: true });
      });

      await watchUtils.whenFalseOnce(mapView, "updating", () => {
        this.setState({ loader: false });
      });
    };
    loadingIconFunction();

    this.setState({
      testWebMap: webMap,
      loadingIconFunction,
      MapImageLayer
    });
  };

  getMapTitle = () => {
    let labelText = Constants.mapLabelLiquefactionVulnerability;
    if(this.getYearLevel() !== 0) {
      const dataModel = this.getSeaLevel() === 0 ? 'Current' : 'Future*';
      const eventModel = dataObject[this.getYearLevel()].seaLevels[this.getSeaLevel()].stormEvents[this.getStormLevel()].label;
      labelText = `${dataModel} potential land damage with a ${eventModel} earthquake event`
    }
    return labelText;
  }

  render() {
    const { loadingIconFunction, loader } = this.state;
    return (
      <div className="app-wrap">
      {this.getDisplayModal() &&
        <Modal setDisplayModal={this.setDisplayModal} setYearLevel={this.setYearLevel} setAcknowledge={this.setAcknowledge}  getAcknowledge={this.getAcknowledge}/>}
        <LeftBar
          getYearLevel={this.getYearLevel}
          setYearLevel={this.setYearLevel}
          getSeaLevel={this.getSeaLevel}
          setSeaLevel={this.setSeaLevel}
          getStormLevel={this.getStormLevel}
          setStormLevel={this.setStormLevel}
          setContoursVisible={this.setContoursVisible}
          getContoursVisible={this.getContoursVisible()}
          loadingIconFunction={loadingIconFunction}
        />
        <div className="column center">
        <h2 className={"mapTitle"}>{this.getMapTitle()}</h2>
          {/* Load esri API and the map */}
          <EsriLoaderReact
            options={{ url: "https://js.arcgis.com/4.11/" }}
            modulesToLoad={[
              "esri/WebMap",
              "esri/views/MapView",
              "esri/widgets/Search",
              "esri/layers/TileLayer",
              "esri/Basemap",
              "esri/layers/VectorTileLayer",
              "esri/layers/FeatureLayer",
              "esri/widgets/Home",
              "esri/geometry/Extent",
              "esri/geometry/SpatialReference",
              "esri/widgets/Compass",
              "esri/core/watchUtils",
              "esri/layers/MapImageLayer"
            ]}
            onReady={this.onMapReady}
          />
          <div
            className={
              loader ? "loader-background" : "loader-background hidden"
            }
          >
            <div className="loader-container">
              <img src={loadingIcon} alt="loading" />
            </div>
          </div>
        </div>
        <RightBar  getYearLevel={this.getYearLevel} />
      </div>
    );
  }
}

export default App;
